var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgFooterInstagramIcon = function SvgFooterInstagramIcon(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6564 0H5.2259C2.3443 0 0 2.34495 0 5.22741V14.7726C0 17.6551 2.3443 20 5.2259 20H15.6564C18.538 20 20.8822 17.6551 20.8822 14.7726V5.22741C20.8822 2.34495 18.538 0 15.6564 0ZM1.8435 5.22741C1.8435 3.36208 3.3611 1.84406 5.2259 1.84406H15.6564C17.5211 1.84406 19.0387 3.36208 19.0387 5.22741V14.7726C19.0387 16.6379 17.5211 18.1559 15.6564 18.1559H5.2259C3.3611 18.1559 1.8435 16.6379 1.8435 14.7726V5.22741Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.441 14.8615C13.1206 14.8615 15.3019 12.6807 15.3019 9.9991C15.3019 7.31747 13.1218 5.13672 10.441 5.13672C7.7601 5.13672 5.58 7.31747 5.58 9.9991C5.58 12.6807 7.7601 14.8615 10.441 14.8615ZM10.441 6.98196C12.105 6.98196 13.4584 8.33578 13.4584 10.0003C13.4584 11.6648 12.105 13.0186 10.441 13.0186C8.777 13.0186 7.4235 11.6648 7.4235 10.0003C7.4235 8.33578 8.777 6.98196 10.441 6.98196Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7521 5.9226C16.4737 5.9226 17.0619 5.33548 17.0619 4.61251C17.0619 3.88953 16.4749 3.30241 15.7521 3.30241C15.0294 3.30241 14.4424 3.88953 14.4424 4.61251C14.4424 5.33548 15.0294 5.9226 15.7521 5.9226Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgFooterInstagramIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/footer-instagram-icon.04e47391afa6c91a63600e2dd9a8548a.svg";